/**
 * Coverup Recommendations Module
 * Shown on swimsuit product pages. Pre-rendered per-color sets are swapped
 * instantly when the shopper changes the suit's color. Each card has its
 * own size dropdown (sizes available in the coverup's pinned color) and an
 * add-to-cart button — styled and wired the same way as
 * matching-bottom-finder.js's result cards.
 */

class CoverupRecommendations {
  constructor(root) {
    this.root = root;
    this.colorOptionPosition = root.getAttribute('data-color-option-position');
    this.sets = Array.from(root.querySelectorAll('.coverup-set'));

    this.onVariantChange = this.onVariantChange.bind(this);
    this.onClick = this.onClick.bind(this);

    document.addEventListener('theme:variant:change', this.onVariantChange);
    root.addEventListener('click', this.onClick);
  }

  // Mirrors Liquid's `| handle` filter closely enough for color names.
  handleize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || !this.colorOptionPosition) return;

    const colorValue = variant['option' + this.colorOptionPosition];
    const colorHandle = this.handleize(colorValue);
    const matchingSet = this.sets.find((set) => set.dataset.color === colorHandle);

    this.sets.forEach((set) => {
      set.hidden = set !== matchingSet;
    });

    this.root.hidden = !matchingSet;
  }

  onClick(event) {
    const button = event.target.closest('[data-coverup-add-to-cart]');
    if (!button) return;

    this.handleAddToCart(button);
  }

  handleAddToCart(button) {
    if (button.disabled) return;

    const card = button.closest('[data-coverup-card]');
    const select = card && card.querySelector('[data-coverup-size-select]');
    const variantId = select && select.value;
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          // Underscore-prefixed properties are hidden from the cart, checkout,
          // and order confirmation, but still show on the order in admin —
          // this is purely for tracking whether shoppers use this module.
          properties: {
            '_Added via': 'Product Recommendations'
          }
        }]
      })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        button.textContent = 'ADDED!';
        button.classList.add('is-added');
        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Error adding to cart:', err);
        button.textContent = 'ERROR — TRY AGAIN';
        button.disabled = false;
      });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-coverup-recommendations]').forEach((root) => {
    new CoverupRecommendations(root);
  });
});
